<template>
  <Skeleton
      class="chat-widget__footer-send"
      v-if="initial"
  ></Skeleton>
  <Button
      class="chat-widget__footer-send"
      v-else
      type="button"
      label="Отправить"
      icon="pi pi-send"
      :loading="blockSending"
      @click="handleClick"
      :disabled="disabled"
      raised
      severity="info"
  />
</template>
<script setup>
import Skeleton from 'primevue/skeleton';
import Button from 'primevue/button';

const props = defineProps({
  initial: {
    type: Boolean,
    required: true
  },
  disabled: {
    type: Boolean,
    required: true
  },
  blockSending: {
    type: Boolean,
    required: true
  }
});
const emit = defineEmits(['send']);
const handleClick = () => {
  emit('send');
};
</script>